import React, { Fragment } from 'react';
import { Card, Heading, Divider, Grid, View, Text, TextField, Flex, Image } from '@aws-amplify/ui-react';
import Rehaziele from "../assets/Rehaziele.jpg";
// import RehazRechts from "../assets/RehazRechts.png";

const RehazieleCard2 = (props) => {
    // console.log(props.rehazieleStamm);
    // console.log(props.thzielevalues);
    const showErreichungsgrad = false;

    if (!props.rehazieleStamm) {
        return null;
    }

    /*
                    templateColumns={{ base: "1fr 13fr 2fr" }}
    
    
    <Image style={{ paddingRight: 80 }}
                            alt="Help Each Other"
                            src={RehazRechts}
                            width="394px"
                        />
    -----
                    {showErreichungsgrad &&
                        <>
                            <View columnStart={1} columnEnd={-1}><Divider /></View>
                            <View columnStart={3} textAlign={'center'}>
                                Erreichungsgrad
                            </View>
                        </>
                    }
    -----
    
                            {showErreichungsgrad &&
                                <View key={i + '1'} columnStart={3} textAlign={'center'}>
                                    <SelectField
                                        name={item.ID + '_' + item.STAMMID + '_SELECT'}
                                        key={'I1' + i}
                                        onChange={handleChange}
                                        isDisabled={props.readOnly}
                                        placeholder="bitte wählen"
                                        value={props.rehaziele && props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].WERT : 0 : 0}
                                    >
                                        {props.thzielevalues && props.thzielevalues.filter(f => f.WERT > 0).map((item, i) => {
                                            return <option key={'O_' + i} value={item.WERT}>{item.BEZEICHNUNG}</option>
                                        })}
                                    </SelectField>
                                </View>
                            }
    
    
                        */

    const handleChange = (e) => {
        // console.log(e)
        const name = e.target.name.split('_');
        const id = parseInt(name[0]);
        const stammid = parseInt(name[1]);
        const typ = name[2]
        const rehaziel = props.rehaziele.filter(f => f.ID === id);
        const value = typ === 'SELECT' ? e.target.value : rehaziel.length > 0 ? rehaziel[0].WERT : 0;
        const text = typ === 'SONST' ? e.target.value : rehaziel.length > 0 ? rehaziel[0].TEXT : '';

        const newRehaziel = { 'ID': id, 'STAMMID': stammid, 'WERT': value, 'TEXT': text }
        // console.log('changed rehaziele', newRehaziele);
        props.handleChange(newRehaziel);
    }

    return (
        <Card variation="elevated">
            <Grid
                columnGap='0.5rem'
                rowGap='0.5rem'
                templateColumns={{ base: "8fr 8fr" }}
            >
                <View columnSpan={2}>
                    <Flex
                        key="F01"
                        direction="row"
                        wrap="wrap" 
                        justifyContent="space-between"
                        alignItems="flex-start"
                        gap="1rem"
                    >
                        <Flex
                            key="F02"
                            direction="column"
                            flex="1 1 200px" 
                            minWidth="200px"
                        >
                            <Heading level={3}>Selbst gesetzte Ziele motivieren!</Heading>
                            <Text>
                                Benennen Sie <b>Ihre 3 wichtigsten Rehaziele</b> in eigenen Worten auf der Basis Ihrer Angaben auf der vorherigen Seite.
                            </Text>
                            <Text>
                                Bitte sprechen Sie mit Ihren Ärzt*innen und Therapeut*innen auch während des Aufenthaltes über Ihre Ziele. Wir unterstützen Sie bei der Erreichung Ihrer Ziele für die Reha wie auch bei der Entwicklung langfristiger Ziele.
                            </Text>
                        </Flex>

                        <Image
                            alt="Road to TOP"
                            src={Rehaziele}
                            maxWidth="300px"
                            width="100%"
                            height="auto"
                            style={{ flex: "1 1 200px", marginTop: "1rem" }}
                        />
                    </Flex>
                </View>

                <View columnStart={1} columnEnd={-1} direction="row" style={{ padding: 5, alignSelf: 'flex-end' }} columnSpan={3}>
                </View>
                <View columnSpan={3}>
                    <Text><b>Zum Beispiel:</b></Text>
                    <Text>Ich möchte körperlich wieder so belastbar werden, dass ich meinen Arbeitstag besser durchhalte.</Text>
                    <Text>Oder: Ich möchte mehr über meine Erkrankung erfahren, um besser damit umgehehen zu können.</Text>
                    <Text>Oder: Ich möchte einen Plan überlegen, wie es beruflich weitergehen kann.</Text>
                    <Text>Oder: .....</Text>
                </View>

                {props.rehazieleStamm.filter(f => f.EBENE === 1 && f.STAMMID === props.hook).map((item, i) =>
                    <Fragment key={i}>
                        <View columnStart={1} columnEnd={-1}><Divider /></View>
                        <View columnStart={1} columnEnd={showErreichungsgrad ? 3 : -1}>
                            <Flex key={'F' + i} direction={'row'}>
                                <Heading level={5} key={i + '0a'}>{item.BEZEICHNUNG}&nbsp;</Heading>
                                <TextField
                                    key={'S' + i}
                                    width={'100%'}
                                    maxLength={256}
                                    name={item.ID + '_' + item.STAMMID + '_SONST'}
                                    onChange={handleChange}
                                    isDisabled={props.readOnly}
                                    value={props.rehaziele.length > 0 ? props.rehaziele.filter(f => f.ID === item.ID).length > 0 ? props.rehaziele.filter(f => f.ID === item.ID)[0].hasOwnProperty('TEXT') ? props.rehaziele.filter(f => f.ID === item.ID)[0].TEXT : '' : '' : ''}
                                />
                            </Flex>
                        </View>
                    </Fragment>
                )}
            </Grid>
            <Text>&nbsp;</Text>
            <Text>&nbsp;</Text>
        </Card >
    );
}

export default RehazieleCard2;